import React from 'react';
import useTokenGate from '../hooks/useTokenGate';

const TokenGate = ({ children, message, onlyWrapped }) => {
  const gatedAccess = useTokenGate(onlyWrapped);

  let warningMessage =
    message ||
    (onlyWrapped
      ? 'Access is restricted to Noundle holders'
      : 'Access is restricted to legacy Noundle holders');

  if (gatedAccess) {
    return children;
  } else if (warningMessage) {
    return (
      <div className="alert alert-warning text-center">{warningMessage}</div>
    );
  } else {
    return null;
  }
};

export default TokenGate;
